import { useState } from 'react';
import { useTranslation as ut } from '@/hooks/useTranslation';
import { useTranslation } from 'react-i18next';
import { Select } from '../dropdowns/Select';
import { LANGUAGES } from '@/constants/constants';
import type { LanguageOptionInterface } from '@/types/types';

export default function LanguageSelector() {
  const { t } = ut('common');
  const savedLang = localStorage.getItem('i18nextLng');
  const [selectedLanguage, setSelectedLanguage] =
    useState<LanguageOptionInterface>(
      savedLang
        ? LANGUAGES.find((lang) => lang.code === savedLang) || LANGUAGES[0]
        : LANGUAGES[0],
    );
  const { i18n } = useTranslation();

  const languageOptionTemplate = (option: LanguageOptionInterface) => {
    return (
      <div className="flex w-full items-center justify-between gap-4">
        <div>{option.name}</div>
        <img width="20" alt={option.name} src={option.img} />
      </div>
    );
  };

  return (
    <Select
      label=""
      value={selectedLanguage}
      onChange={(e) => {
        setSelectedLanguage(e.value);
        i18n.changeLanguage(e.value.code);
      }}
      options={LANGUAGES}
      pt={{
        itemLabel: {
          className: 'w-full',
        },
      }}
      optionLabel="name"
      placeholder={t('selectLang')}
      itemTemplate={languageOptionTemplate}
      valueTemplate={(option, p) => {
        if (!option) {
          return p.placeholder;
        }
        return languageOptionTemplate(option);
      }}
      className="h-12 w-full"
    />
  );
}
